import { render, staticRenderFns } from "./all-clients-summary.vue?vue&type=template&id=22cf9071&scoped=true&"
import script from "./all-clients-summary.vue?vue&type=script&lang=ts&"
export * from "./all-clients-summary.vue?vue&type=script&lang=ts&"
import style0 from "./all-clients-summary.vue?vue&type=style&index=0&id=22cf9071&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cf9071",
  null
  
)

export default component.exports